export const talentsBatch31 = [
  {
    id: 253,
    name: '林晓峰',
    role: '销售猎手',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20sales%20hunter%20in%20sharp%20modern%20business%20suit%20confident%20hunting%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-253&orientation=portrait',
    salary: '¥2000/月',
    tags: ['客户开发', '冷启动拓客', '商机挖掘', '销售漏斗', '高压成交', '业绩冲刺'],
    description: '专注于新客户开发与商机挖掘的销售猎手，擅长冷启动拓客和高压成交，持续为企业输送优质客户资源。',
    skills: [
      { name: '冷启动客户开发', level: 97 },
      { name: '商机挖掘能力', level: 96 },
      { name: '销售漏斗管理', level: 95 },
      { name: '高压成交技巧', level: 94 },
      { name: '客户需求洞察', level: 93 },
    ],
    performance: { monthly_new_clients: 25, conversion_rate: '38%' },
    cases: [
      { title: '某SaaS公司新客开发', result: '3个月内开发新客户80家，签约率38%，带来年度合同额1200万', duration: '3个月', tags: ['SaaS销售', '新客开发', '高签约率'] },
      { title: '某制造企业大客户猎取', result: '成功猎取行业TOP10客户5家，单笔最大合同500万，年度业绩翻倍', duration: '6个月', tags: ['大客户', '猎取成功', '业绩翻倍'] },
      { title: '某金融产品冷启动推广', result: '从零开始冷启动，首月开发潜在客户200+，转化付费客户45家', duration: '1个月', tags: ['冷启动', '快速转化', '金融产品'] },
    ],
    reviews: [
      { name: '张总监', company: '某SaaS公司', rating: 5, content: '林晓峰的客户开发能力极强，3个月带来了80家新客户，签约率高达38%，是我们团队的销售标杆。', date: '2024-02-15' },
      { name: '王CEO', company: '某制造企业', rating: 5, content: '他成功猎取了5家行业TOP10客户，这是我们之前想都不敢想的突破，年度业绩直接翻倍。', date: '2024-03-10' },
      { name: '李经理', company: '某金融公司', rating: 5, content: '冷启动能力超强，首月就转化了45家付费客户，执行力和韧性都非常出色。', date: '2024-04-05' },
    ],
    profile: {
      identity: { roleName: '销售猎手，专注于新客户开发与商机挖掘', personality: '进取心强、抗压能力强、善于突破、执行力极强', background: '销售管理专业背景，精通客户开发、商机挖掘、成交技巧' },
      mission: { duties: '负责冷启动拓客、商机挖掘、销售漏斗管理、高压成交', goals: '月度新客开发25家以上，签约率达到35%以上', collaboration: '与市场团队协作线索，与售后团队交接客户' },
      delivery: { example: '输出客户开发报告、商机清单、成交方案', workflow: '1.目标客户识别 → 2.冷启动接触 → 3.需求挖掘 → 4.方案呈现 → 5.高压成交 → 6.合同签署', format: '提供客户清单、跟进记录、成交报告等标准化交付物' },
      metrics: { quality: '新客开发数量、签约率、合同金额、客户质量', acceptance: '新客稳定增长，签约率达标，合同金额达标', improvement: '持续优化开发策略，提升成交技巧，扩大客户来源' },
    },
  },
  {
    id: 254,
    name: '陈美玲',
    role: '外呼专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20outbound%20call%20specialist%20in%20smart%20business%20casual%20attire%20warm%20professional%20expression%20age%2027%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-254&orientation=portrait',
    salary: '¥1125/月',
    tags: ['电话外呼', '话术设计', '线索筛选', '预约邀约', '客户跟进', '数据录入'],
    description: '专业电话外呼与线索筛选专员，擅长话术设计和客户预约邀约，高效完成外呼任务并精准筛选优质线索。',
    skills: [
      { name: '电话话术设计', level: 95 },
      { name: '线索精准筛选', level: 94 },
      { name: '客户预约邀约', level: 96 },
      { name: '异议处理能力', level: 93 },
      { name: '数据录入整理', level: 92 },
    ],
    performance: { daily_calls: 120, appointment_rate: '22%' },
    cases: [
      { title: '某教育机构招生外呼', result: '日均外呼120通，预约到访率22%，月度带来有效线索300+，招生转化率提升40%', duration: '持续服务', tags: ['教育招生', '高预约率', '线索质量'] },
      { title: '某保险公司客户激活', result: '外呼沉睡客户5000人，成功激活1200人，激活率24%，带来保费收入800万', duration: '2个月', tags: ['客户激活', '沉睡唤醒', '保费增长'] },
      { title: '某SaaS产品试用邀约', result: '外呼潜在客户2000家，成功邀约试用450家，试用转付费率35%', duration: '1个月', tags: ['试用邀约', '高转化', 'SaaS推广'] },
    ],
    reviews: [
      { name: '刘招生主任', company: '某教育机构', rating: 5, content: '陈美玲的外呼话术非常专业，预约到访率达到22%，远超行业平均水平，招生效果非常好。', date: '2024-02-20' },
      { name: '赵销售总监', company: '某保险公司', rating: 5, content: '她的客户激活能力很强，5000个沉睡客户激活了1200个，带来了800万保费，超出预期。', date: '2024-03-15' },
      { name: '孙产品经理', company: '某SaaS公司', rating: 5, content: '邀约试用的转化率35%非常高，她的话术设计很有针对性，客户体验也很好。', date: '2024-04-01' },
    ],
    profile: {
      identity: { roleName: '外呼专员，专注于电话外呼与线索筛选', personality: '亲和力强、耐心细致、抗拒绝能力强、执行力好', background: '市场营销或客服专业背景，精通电话销售、话术设计、线索管理' },
      mission: { duties: '负责电话外呼、话术执行、线索筛选、预约邀约、数据录入', goals: '日均外呼100通以上，预约率达到20%以上', collaboration: '与销售团队交接线索，与市场团队反馈数据' },
      delivery: { example: '输出外呼记录、线索清单、预约确认', workflow: '1.名单准备 → 2.话术执行 → 3.线索筛选 → 4.预约确认 → 5.数据录入 → 6.跟进提醒', format: '提供外呼日报、线索清单、预约记录等标准化交付物' },
      metrics: { quality: '外呼量、预约率、线索质量、数据准确性', acceptance: '外呼量达标，预约率达标，线索质量高', improvement: '持续优化话术，提升预约率，改善线索质量' },
    },
  },
  {
    id: 255,
    name: '王建明',
    role: '销售顾问',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20sales%20consultant%20in%20elegant%20business%20suit%20consultative%20advisory%20expression%20age%2035%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-255&orientation=portrait',
    salary: '¥2250/月',
    tags: ['顾问式销售', '需求诊断', '方案定制', '价值呈现', '客户教育', '长期关系'],
    description: '顾问式销售专家，擅长深度需求诊断和定制化方案呈现，通过价值教育建立长期客户关系，实现高客单价成交。',
    skills: [
      { name: '需求深度诊断', level: 97 },
      { name: '定制方案设计', level: 96 },
      { name: '价值呈现能力', level: 98 },
      { name: '客户教育引导', level: 95 },
      { name: '长期关系维护', level: 94 },
    ],
    performance: { avg_deal_size: '¥85000', customer_satisfaction: '96%' },
    cases: [
      { title: '某企业软件顾问销售', result: '通过顾问式销售方法，平均客单价从3万提升至8.5万，年度销售额突破2000万', duration: '1年', tags: ['顾问销售', '客单提升', '销售突破'] },
      { title: '某咨询公司大单成交', result: '深度诊断客户需求，定制解决方案，成功签约500万咨询项目，客户满意度96%', duration: '3个月', tags: ['大单成交', '需求诊断', '高满意度'] },
      { title: '某金融机构方案销售', result: '为金融机构定制专属方案，通过价值教育推动决策，签约率提升60%', duration: '6个月', tags: ['方案销售', '价值教育', '签约提升'] },
    ],
    reviews: [
      { name: '周总经理', company: '某企业', rating: 5, content: '王建明的顾问式销售让我们的客单价翻了近3倍，他真正理解客户需求，提供的方案非常有价值。', date: '2024-02-10' },
      { name: '吴董事长', company: '某咨询公司', rating: 5, content: '他的需求诊断能力极强，500万的大单成交过程非常顺畅，客户对方案非常认可。', date: '2024-03-20' },
      { name: '郑副总裁', company: '某金融机构', rating: 5, content: '他的价值教育做得非常好，让我们的决策层真正理解了产品价值，签约率提升了60%。', date: '2024-04-12' },
    ],
    profile: {
      identity: { roleName: '销售顾问，专注于顾问式销售与高价值方案成交', personality: '专业严谨、善于倾听、逻辑清晰、客户导向', background: '商业管理或咨询专业背景，精通顾问式销售、需求分析、方案设计' },
      mission: { duties: '负责需求诊断、方案定制、价值呈现、客户教育、关系维护', goals: '平均客单价达到8万以上，客户满意度达到95%以上', collaboration: '与产品团队协作方案，与售后团队交接服务' },
      delivery: { example: '输出需求诊断报告、定制方案、价值呈现材料', workflow: '1.需求诊断 → 2.方案设计 → 3.价值呈现 → 4.客户教育 → 5.异议处理 → 6.合同签署', format: '提供诊断报告、方案文档、演示材料等标准化交付物' },
      metrics: { quality: '客单价、签约率、客户满意度、方案质量', acceptance: '客单价达标，签约率高，客户满意', improvement: '持续深化行业知识，提升方案质量，优化价值呈现' },
    },
  },
  {
    id: 256,
    name: '赵丽华',
    role: '客户经理',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20account%20manager%20in%20polished%20business%20attire%20warm%20professional%20expression%20age%2031%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-256&orientation=portrait',
    salary: '¥1875/月',
    tags: ['客户管理', '账户增长', '续费维护', '交叉销售', '客户健康', 'NPS提升'],
    description: '专业客户经理，擅长账户健康管理和续费增购推动，通过深度客户关系实现账户持续增长和高NPS。',
    skills: [
      { name: '账户健康管理', level: 96 },
      { name: '续费增购推动', level: 97 },
      { name: '交叉销售能力', level: 95 },
      { name: 'NPS提升策略', level: 94 },
      { name: '客户关系维护', level: 98 },
    ],
    performance: { account_retention: '92%', upsell_rate: '45%' },
    cases: [
      { title: '某SaaS公司客户成功管理', result: '管理200+企业客户，续费率92%，增购率45%，NPS从42提升至68', duration: '1年', tags: ['客户成功', '高续费率', 'NPS提升'] },
      { title: '某金融服务账户增长', result: '深度经营50个大客户，年度账户增长率35%，交叉销售成功率60%', duration: '6个月', tags: ['账户增长', '交叉销售', '大客户'] },
      { title: '某企业服务客户挽留', result: '挽留流失风险客户30家，成功挽留25家，挽留率83%，避免流失合同额500万', duration: '3个月', tags: ['客户挽留', '高挽留率', '合同保全'] },
    ],
    reviews: [
      { name: '陈运营总监', company: '某SaaS公司', rating: 5, content: '赵丽华的客户管理能力非常出色，续费率92%在行业内属于顶尖水平，NPS提升也非常显著。', date: '2024-02-25' },
      { name: '林副总裁', company: '某金融服务公司', rating: 5, content: '她的账户增长策略很有效，交叉销售成功率60%，大客户经营做得非常好。', date: '2024-03-18' },
      { name: '黄总监', company: '某企业服务公司', rating: 5, content: '她的客户挽留能力很强，83%的挽留率帮我们保住了500万合同额，非常专业。', date: '2024-04-08' },
    ],
    profile: {
      identity: { roleName: '客户经理，专注于账户健康管理与持续增长', personality: '亲和力强、责任心重、善于沟通、以客户为中心', background: '客户成功或销售管理专业背景，精通账户管理、续费策略、交叉销售' },
      mission: { duties: '负责账户健康管理、续费推动、增购销售、NPS提升、客户关系维护', goals: '续费率达到90%以上，增购率达到40%以上，NPS达到60以上', collaboration: '与销售团队协作增购，与产品团队反馈需求，与客服团队协作服务' },
      delivery: { example: '输出账户健康报告、续费计划、增购方案', workflow: '1.账户健康评估 → 2.风险预警 → 3.续费推动 → 4.增购挖掘 → 5.NPS收集 → 6.改进行动', format: '提供健康报告、续费记录、增购方案等标准化交付物' },
      metrics: { quality: '续费率、增购率、NPS、账户健康分、客户满意度', acceptance: '续费率达标，增购率高，NPS良好', improvement: '持续优化客户管理策略，提升服务质量，深化客户关系' },
    },
  },
  {
    id: 257,
    name: '刘志远',
    role: '商务拓展',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20business%20development%20manager%20in%20executive%20business%20attire%20strategic%20visionary%20expression%20age%2036%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-257&orientation=portrait',
    salary: '¥2750/月',
    tags: ['商务拓展', '战略合作', '渠道开发', '生态建设', '合作谈判', '市场进入'],
    description: '商务拓展与战略合作专家，擅长渠道开发和生态合作建设，通过战略合作推动企业市场扩张和业务增长。',
    skills: [
      { name: '战略合作谈判', level: 97 },
      { name: '渠道开发能力', level: 96 },
      { name: '生态建设策略', level: 95 },
      { name: '市场进入规划', level: 94 },
      { name: '合作关系管理', level: 98 },
    ],
    performance: { partnerships_signed: 30, revenue_from_partners: '¥5000万/年' },
    cases: [
      { title: '某科技公司渠道生态建设', result: '建立渠道合作体系，签约渠道合作伙伴30家，渠道贡献收入5000万，占总收入40%', duration: '1年', tags: ['渠道建设', '生态合作', '收入贡献'] },
      { title: '某平台战略合作谈判', result: '谈判并签署3个战略合作协议，带来用户增长200万，品牌影响力大幅提升', duration: '6个月', tags: ['战略合作', '用户增长', '品牌提升'] },
      { title: '某企业新市场进入', result: '规划并执行新市场进入策略，6个月内建立本地合作网络，市场份额达到8%', duration: '6个月', tags: ['市场进入', '本地网络', '份额增长'] },
    ],
    reviews: [
      { name: '张CEO', company: '某科技公司', rating: 5, content: '刘志远建立的渠道生态非常成功，30家合作伙伴贡献了5000万收入，是公司增长的重要引擎。', date: '2024-02-28' },
      { name: '王副总裁', company: '某平台公司', rating: 5, content: '他的谈判能力很强，3个战略合作协议都谈得非常好，带来了200万用户增长。', date: '2024-03-22' },
      { name: '李总经理', company: '某企业', rating: 5, content: '他的新市场进入策略非常有效，6个月就建立了本地合作网络，市场份额达到8%。', date: '2024-04-15' },
    ],
    profile: {
      identity: { roleName: '商务拓展专家，专注于战略合作与渠道生态建设', personality: '战略思维强、善于谈判、关系建设能力强、执行力强', background: '商业管理或市场营销专业背景，精通商务拓展、渠道管理、战略合作' },
      mission: { duties: '负责渠道开发、战略合作谈判、生态建设、市场进入规划', goals: '年度签约合作伙伴20家以上，渠道收入贡献达到总收入30%以上', collaboration: '与销售团队协作渠道，与产品团队确认合作方案，与法务团队审核合同' },
      delivery: { example: '输出合作方案、渠道策略、市场进入计划', workflow: '1.目标识别 → 2.接触洽谈 → 3.方案设计 → 4.合同谈判 → 5.合作启动 → 6.关系维护', format: '提供合作协议、渠道手册、市场计划等标准化交付物' },
      metrics: { quality: '合作伙伴数量、渠道收入、合作质量、市场份额', acceptance: '合作伙伴稳定增长，渠道收入达标，合作质量高', improvement: '持续优化合作模式，扩大合作网络，提升合作价值' },
    },
  },
  {
    id: 258,
    name: '周晓燕',
    role: '微信拓客专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20WeChat%20marketing%20specialist%20in%20modern%20casual%20business%20attire%20friendly%20approachable%20expression%20age%2028%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-258&orientation=portrait',
    salary: '¥1250/月',
    tags: ['微信拓客', '朋友圈运营', '加粉策略', '社交裂变', '私信转化', '微信生态'],
    description: '微信生态拓客与社交裂变专家，擅长朋友圈内容运营和精准加粉策略，通过微信社交网络实现高效客户获取。',
    skills: [
      { name: '精准加粉策略', level: 95 },
      { name: '朋友圈内容运营', level: 96 },
      { name: '社交裂变设计', level: 94 },
      { name: '私信转化技巧', level: 97 },
      { name: '微信生态运营', level: 93 },
    ],
    performance: { monthly_new_friends: 500, conversion_rate: '18%' },
    cases: [
      { title: '某美容品牌微信拓客', result: '月均新增精准好友500人，私信转化率18%，3个月带来新客户270人，销售额增长150万', duration: '3个月', tags: ['美容品牌', '精准拓客', '销售增长'] },
      { title: '某教育机构微信裂变', result: '设计裂变活动，7天新增好友3000人，报名转化率25%，带来招生收入200万', duration: '7天', tags: ['裂变活动', '快速增粉', '招生转化'] },
      { title: '某本地商家朋友圈运营', result: '优化朋友圈内容策略，互动率提升300%，到店客流增加80%，月营业额提升60万', duration: '2个月', tags: ['朋友圈运营', '互动提升', '到店增长'] },
    ],
    reviews: [
      { name: '陈老板', company: '某美容品牌', rating: 5, content: '周晓燕的微信拓客能力很强，每月稳定带来500个精准好友，转化率18%，销售额增长非常明显。', date: '2024-02-18' },
      { name: '刘校长', company: '某教育机构', rating: 5, content: '她设计的裂变活动非常成功，7天新增3000好友，招生收入200万，效果超出预期。', date: '2024-03-12' },
      { name: '王店主', company: '某本地商家', rating: 5, content: '她的朋友圈运营让我们的互动率提升了3倍，到店客流增加了80%，非常实用。', date: '2024-04-02' },
    ],
    profile: {
      identity: { roleName: '微信拓客专员，专注于微信生态客户获取与转化', personality: '亲和力强、创意丰富、执行力好、善于社交', background: '新媒体或市场营销专业背景，精通微信生态、社交裂变、私域运营' },
      mission: { duties: '负责精准加粉、朋友圈运营、裂变活动设计、私信转化', goals: '月度新增精准好友400人以上，私信转化率达到15%以上', collaboration: '与私域团队协作运营，与销售团队交接线索' },
      delivery: { example: '输出拓客方案、朋友圈内容、裂变活动设计', workflow: '1.目标用户定位 → 2.加粉策略执行 → 3.朋友圈内容发布 → 4.私信跟进 → 5.裂变活动 → 6.转化成交', format: '提供拓客日报、内容日历、转化记录等标准化交付物' },
      metrics: { quality: '新增好友数、转化率、销售额贡献、内容互动率', acceptance: '新增好友达标，转化率达标，销售贡献明显', improvement: '持续优化拓客策略，提升内容质量，改善转化路径' },
    },
  },
  {
    id: 259,
    name: '吴思远',
    role: '私域培育专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20private%20domain%20nurturing%20specialist%20in%20modern%20business%20casual%20attire%20patient%20strategic%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-259&orientation=portrait',
    salary: '¥1500/月',
    tags: ['私域培育', '用户分层', '内容触达', '信任建立', '购买意愿', '生命周期'],
    description: '私域用户培育与信任建立专家，擅长用户分层管理和个性化内容触达，通过系统化培育提升用户购买意愿和转化率。',
    skills: [
      { name: '用户分层管理', level: 96 },
      { name: '个性化内容触达', level: 95 },
      { name: '信任建立策略', level: 97 },
      { name: '购买意愿激活', level: 94 },
      { name: '生命周期管理', level: 93 },
    ],
    performance: { nurture_conversion: '32%', avg_nurture_cycle: '21天' },
    cases: [
      { title: '某健康品牌私域培育', result: '建立分层培育体系，21天培育周期，转化率从12%提升至32%，月度私域销售额增长200%', duration: '4个月', tags: ['健康品牌', '分层培育', '转化提升'] },
      { title: '某教育机构潜客培育', result: '培育潜在学员5000人，通过内容触达和信任建立，报名转化率28%，招生收入增长300万', duration: '3个月', tags: ['潜客培育', '信任建立', '招生增长'] },
      { title: '某金融产品用户激活', result: '激活沉睡用户3000人，通过个性化内容推送，购买意愿提升60%，成功转化900人', duration: '2个月', tags: ['用户激活', '个性化推送', '购买转化'] },
    ],
    reviews: [
      { name: '郑市场总监', company: '某健康品牌', rating: 5, content: '吴思远的私域培育体系非常专业，转化率从12%提升到32%，私域销售额翻了3倍，效果显著。', date: '2024-02-22' },
      { name: '孙招生总监', company: '某教育机构', rating: 5, content: '他的潜客培育做得非常好，信任建立策略很有效，28%的报名转化率超出了我们的预期。', date: '2024-03-16' },
      { name: '钱运营经理', company: '某金融公司', rating: 5, content: '他的个性化内容推送很精准，激活了3000个沉睡用户，成功转化900人，效果很好。', date: '2024-04-06' },
    ],
    profile: {
      identity: { roleName: '私域培育专员，专注于用户信任建立与购买意愿激活', personality: '耐心细致、善于沟通、内容创作能力强、数据敏感', background: '用户运营或内容营销专业背景，精通私域运营、用户培育、内容策略' },
      mission: { duties: '负责用户分层、内容触达、信任建立、购买意愿激活、生命周期管理', goals: '培育转化率达到30%以上，平均培育周期控制在25天以内', collaboration: '与私域运营团队协作，与销售团队交接转化线索' },
      delivery: { example: '输出培育方案、内容日历、用户分层报告', workflow: '1.用户分层 → 2.培育路径设计 → 3.内容触达 → 4.互动跟进 → 5.意愿评估 → 6.转化推动', format: '提供培育方案、内容素材、转化报告等标准化交付物' },
      metrics: { quality: '培育转化率、培育周期、用户活跃度、购买意愿分', acceptance: '转化率达标，培育周期合理，用户活跃', improvement: '持续优化培育路径，提升内容质量，缩短培育周期' },
    },
  },
  {
    id: 260,
    name: '郑雨桐',
    role: '邀约成交专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20invitation%20closing%20specialist%20in%20professional%20business%20attire%20confident%20persuasive%20expression%20age%2029%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-260&orientation=portrait',
    salary: '¥1625/月',
    tags: ['邀约成交', '到访转化', '现场逼单', '成交话术', '异议处理', '签单技巧'],
    description: '邀约到访与现场成交专家，擅长高效邀约话术和现场逼单技巧，将潜在客户转化为实际成交，提升到访签单率。',
    skills: [
      { name: '高效邀约话术', level: 96 },
      { name: '现场逼单技巧', level: 97 },
      { name: '异议处理能力', level: 95 },
      { name: '成交节奏把控', level: 94 },
      { name: '客户心理洞察', level: 93 },
    ],
    performance: { visit_rate: '65%', onsite_close_rate: '48%' },
    cases: [
      { title: '某房产项目邀约成交', result: '邀约到访率65%，现场成交率48%，月度成交额突破3000万，成为项目销冠', duration: '持续服务', tags: ['房产销售', '高到访率', '成交冠军'] },
      { title: '某教育机构招生成交', result: '邀约家长到访，现场成交率52%，月度招生200人，招生收入增长180%', duration: '3个月', tags: ['教育招生', '现场成交', '收入增长'] },
      { title: '某健身房会员成交', result: '优化邀约和成交话术，到访转化率从30%提升至48%，月度新增会员150人', duration: '2个月', tags: ['健身会员', '转化提升', '话术优化'] },
    ],
    reviews: [
      { name: '李销售总监', company: '某房产公司', rating: 5, content: '郑雨桐的邀约和成交能力非常强，到访率65%、成交率48%都是团队最高，月度成交额突破3000万。', date: '2024-02-20' },
      { name: '赵校长', company: '某教育机构', rating: 5, content: '她的现场成交话术非常专业，52%的成交率让我们的招生收入增长了180%，非常出色。', date: '2024-03-14' },
      { name: '孙店长', company: '某健身房', rating: 5, content: '她优化的话术让到访转化率从30%提升到48%，每月新增150个会员，效果非常好。', date: '2024-04-04' },
    ],
    profile: {
      identity: { roleName: '邀约成交专员，专注于邀约到访与现场成交转化', personality: '热情积极、善于沟通、抗压能力强、成交欲望强', background: '销售或客服专业背景，精通邀约话术、成交技巧、异议处理' },
      mission: { duties: '负责客户邀约、到访接待、现场成交、异议处理、签单跟进', goals: '邀约到访率达到60%以上，现场成交率达到45%以上', collaboration: '与外呼团队协作邀约，与销售顾问配合成交' },
      delivery: { example: '输出邀约话术、成交方案、签单记录', workflow: '1.客户筛选 → 2.邀约话术 → 3.到访接待 → 4.需求了解 → 5.方案呈现 → 6.现场逼单 → 7.签单成交', format: '提供邀约记录、成交报告、签单文件等标准化交付物' },
      metrics: { quality: '邀约到访率、现场成交率、签单金额、客户满意度', acceptance: '到访率达标，成交率高，签单金额达标', improvement: '持续优化邀约话术，提升成交技巧，改善客户体验' },
    },
  },
  {
    id: 261,
    name: '孙浩然',
    role: '签单成交专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20contract%20closing%20specialist%20in%20sharp%20business%20suit%20confident%20decisive%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-261&orientation=portrait',
    salary: '¥1750/月',
    tags: ['签单成交', '合同谈判', '价格谈判', '条款确认', '快速签约', '成交率'],
    description: '合同签约与价格谈判专家，擅长快速推进签约流程和价格条款谈判，确保商机高效转化为实际合同。',
    skills: [
      { name: '合同条款谈判', level: 96 },
      { name: '价格谈判技巧', level: 97 },
      { name: '快速签约推进', level: 95 },
      { name: '风险条款识别', level: 94 },
      { name: '成交节奏把控', level: 98 },
    ],
    performance: { monthly_contracts: 20, avg_close_cycle: '7天' },
    cases: [
      { title: '某IT公司合同签约加速', result: '优化签约流程，平均签约周期从21天缩短至7天，月度签约合同20份，合同总额800万', duration: '持续服务', tags: ['签约加速', '周期缩短', '合同增长'] },
      { title: '某服务公司价格谈判', result: '主导价格谈判，在保持利润率的前提下，成功签约率提升40%，年度合同额增长600万', duration: '6个月', tags: ['价格谈判', '利润保持', '合同增长'] },
      { title: '某大客户合同攻坚', result: '攻坚卡单3个月的大客户合同，通过条款优化和关系推动，成功签约500万合同', duration: '1个月', tags: ['大客户攻坚', '卡单突破', '大额合同'] },
    ],
    reviews: [
      { name: '王销售VP', company: '某IT公司', rating: 5, content: '孙浩然的签约推进能力极强，把签约周期从21天缩短到7天，月度合同额达到800万，非常高效。', date: '2024-02-26' },
      { name: '陈总经理', company: '某服务公司', rating: 5, content: '他的价格谈判技巧很高超，在保持利润率的同时提升了40%的签约率，年度合同额增长600万。', date: '2024-03-20' },
      { name: '刘CEO', company: '某企业', rating: 5, content: '他攻坚了卡单3个月的大客户，成功签约500万合同，这个突破对我们非常重要。', date: '2024-04-10' },
    ],
    profile: {
      identity: { roleName: '签单成交专员，专注于合同签约推进与价格谈判', personality: '果断决策、善于谈判、抗压能力强、执行力强', background: '销售或法务专业背景，精通合同谈判、价格策略、签约流程' },
      mission: { duties: '负责合同谈判、价格谈判、签约推进、条款确认、成交跟进', goals: '月度签约合同15份以上，平均签约周期控制在10天以内', collaboration: '与销售顾问协作谈判，与法务团队审核合同，与财务团队确认条款' },
      delivery: { example: '输出谈判方案、合同文件、签约记录', workflow: '1.商机确认 → 2.条款谈判 → 3.价格协商 → 4.合同起草 → 5.审核确认 → 6.签约成交', format: '提供谈判记录、合同文件、签约报告等标准化交付物' },
      metrics: { quality: '签约数量、签约周期、合同金额、成交率', acceptance: '签约数量达标，周期合理，合同金额达标', improvement: '持续优化谈判策略，缩短签约周期，提升成交率' },
    },
  },
  {
    id: 262,
    name: '钱晓雯',
    role: '客户拓展策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20customer%20expansion%20strategist%20in%20elegant%20business%20attire%20strategic%20analytical%20expression%20age%2034%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-262&orientation=portrait',
    salary: '¥2500/月',
    tags: ['拓展策略', '市场细分', '客户画像', '增长规划', '竞争分析', '机会识别'],
    description: '客户拓展策略与市场增长专家，擅长市场细分和客户画像构建，制定精准的客户拓展策略，驱动业务持续增长。',
    skills: [
      { name: '市场细分分析', level: 97 },
      { name: '客户画像构建', level: 96 },
      { name: '拓展策略制定', level: 98 },
      { name: '竞争分析能力', level: 95 },
      { name: '增长规划能力', level: 94 },
    ],
    performance: { strategy_success_rate: '82%', market_share_growth: '+15%' },
    cases: [
      { title: '某科技公司市场拓展策略', result: '制定精准拓展策略，识别3个高价值细分市场，市场份额提升15%，年度新增收入3000万', duration: '6个月', tags: ['市场拓展', '细分市场', '份额增长'] },
      { title: '某消费品牌客户画像优化', result: '重构客户画像，精准定位目标客群，营销效率提升60%，获客成本降低40%', duration: '3个月', tags: ['客户画像', '精准定位', '效率提升'] },
      { title: '某B2B企业增长规划', result: '制定3年增长规划，识别10个增长机会，执行后年度增长率达到45%', duration: '2个月', tags: ['增长规划', '机会识别', '高增长率'] },
    ],
    reviews: [
      { name: '周战略总监', company: '某科技公司', rating: 5, content: '钱晓雯的拓展策略非常精准，识别的3个细分市场都非常有价值，市场份额提升15%，新增收入3000万。', date: '2024-02-24' },
      { name: '吴市场总监', company: '某消费品牌', rating: 5, content: '她重构的客户画像非常准确，营销效率提升60%，获客成本降低40%，效果非常显著。', date: '2024-03-18' },
      { name: '郑CEO', company: '某B2B企业', rating: 5, content: '她制定的增长规划非常有前瞻性，识别的增长机会都很准确，年度增长率达到45%。', date: '2024-04-12' },
    ],
    profile: {
      identity: { roleName: '客户拓展策略师，专注于市场细分与增长策略制定', personality: '战略思维强、数据驱动、善于分析、前瞻性强', background: '战略管理或市场营销专业背景，精通市场分析、客户研究、增长策略' },
      mission: { duties: '负责市场细分、客户画像、拓展策略制定、竞争分析、增长规划', goals: '策略成功率达到80%以上，市场份额年度增长10%以上', collaboration: '与销售团队执行策略，与市场团队协作推广，与管理层汇报规划' },
      delivery: { example: '输出拓展策略报告、客户画像、增长规划', workflow: '1.市场分析 → 2.细分识别 → 3.画像构建 → 4.策略制定 → 5.执行规划 → 6.效果评估', format: '提供策略报告、画像文档、规划方案等标准化交付物' },
      metrics: { quality: '策略成功率、市场份额增长、获客效率、增长率', acceptance: '策略显著提升，市场份额增长，获客效率提升', improvement: '持续深化市场洞察，优化策略方法，提升规划准确性' },
    },
  },
  {
    id: 263,
    name: '李明轩',
    role: '销售教练',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20sales%20coach%20in%20authoritative%20business%20attire%20inspiring%20mentoring%20expression%20age%2040%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-263&orientation=portrait',
    salary: '¥3125/月',
    tags: ['销售培训', '团队辅导', '话术优化', '能力提升', '绩效改善', '销售方法论'],
    description: '专业销售教练，擅长销售团队能力诊断和系统化培训，通过话术优化和方法论传授，大幅提升销售团队整体业绩。',
    skills: [
      { name: '销售能力诊断', level: 97 },
      { name: '系统化培训设计', level: 96 },
      { name: '话术优化指导', level: 98 },
      { name: '绩效改善辅导', level: 95 },
      { name: '销售方法论传授', level: 94 },
    ],
    performance: { teams_coached: 20, avg_performance_improvement: '+65%' },
    cases: [
      { title: '某科技公司销售团队提升', result: '培训50人销售团队，建立标准化销售方法论，团队整体业绩提升65%，人均产出提升80%', duration: '6个月', tags: ['团队培训', '方法论建立', '业绩提升'] },
      { title: '某金融公司话术优化', result: '优化销售话术体系，建立异议处理手册，成交率从18%提升至32%，月度业绩增长75%', duration: '3个月', tags: ['话术优化', '成交率提升', '业绩增长'] },
      { title: '某电商公司新人培训', result: '设计新人培训体系，新人达标周期从3个月缩短至6周，新人首月业绩达到老员工70%', duration: '持续服务', tags: ['新人培训', '达标加速', '快速成长'] },
    ],
    reviews: [
      { name: '张销售VP', company: '某科技公司', rating: 5, content: '李明轩的销售培训非常专业，他建立的方法论让团队业绩提升了65%，人均产出提升80%，是我们最好的投资。', date: '2024-02-28' },
      { name: '王总监', company: '某金融公司', rating: 5, content: '他优化的话术体系非常实用，成交率从18%提升到32%，月度业绩增长75%，效果立竿见影。', date: '2024-03-22' },
      { name: '陈HR总监', company: '某电商公司', rating: 5, content: '他设计的新人培训体系非常高效，新人达标周期缩短了一半，首月业绩就能达到老员工70%。', date: '2024-04-16' },
    ],
    profile: {
      identity: { roleName: '销售教练，专注于销售团队能力提升与业绩改善', personality: '激励性强、善于教学、经验丰富、结果导向', background: '销售管理或培训专业背景，精通销售方法论、培训设计、绩效辅导' },
      mission: { duties: '负责销售能力诊断、培训设计、话术优化、绩效辅导、方法论建立', goals: '培训后团队业绩提升50%以上，新人达标周期缩短40%以上', collaboration: '与销售管理层确认目标，与HR团队协作培训，与销售团队持续辅导' },
      delivery: { example: '输出培训方案、话术手册、辅导报告', workflow: '1.能力诊断 → 2.培训设计 → 3.话术优化 → 4.培训执行 → 5.实战辅导 → 6.效果评估', format: '提供培训材料、话术手册、辅导报告等标准化交付物' },
      metrics: { quality: '业绩提升幅度、成交率提升、新人达标周期、培训满意度', acceptance: '业绩显著提升，成交率提高，新人快速成长', improvement: '持续更新培训内容，优化辅导方法，关注团队反馈' },
    },
  },
  {
    id: 264,
    name: '赵天宇',
    role: '赢单策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20deal%20winning%20strategist%20in%20executive%20business%20suit%20strategic%20confident%20expression%20age%2038%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-264&orientation=portrait',
    salary: '¥3500/月',
    tags: ['赢单策略', '竞争分析', '决策影响', '关键人攻关', '方案差异化', '大单成交'],
    description: '大单赢单策略与竞争分析专家，擅长复杂销售场景中的竞争策略制定和关键决策人影响，提升大单赢单率。',
    skills: [
      { name: '竞争策略制定', level: 98 },
      { name: '关键人影响力', level: 97 },
      { name: '方案差异化设计', level: 96 },
      { name: '决策链分析', level: 95 },
      { name: '大单推进能力', level: 94 },
    ],
    performance: { large_deal_win_rate: '72%', avg_deal_size: '¥300万' },
    cases: [
      { title: '某IT公司政府大单赢单', result: '制定赢单策略，攻关关键决策人，方案差异化呈现，成功赢得2000万政府项目', duration: '4个月', tags: ['政府大单', '赢单策略', '关键人攻关'] },
      { title: '某咨询公司竞争性投标', result: '分析竞争对手弱点，制定差异化方案，在5家竞争中脱颖而出，赢得800万咨询合同', duration: '2个月', tags: ['竞争投标', '差异化方案', '赢得合同'] },
      { title: '某企业服务大客户赢单', result: '通过决策链分析和关键人攻关，将胜率从30%提升至72%，年度大单赢单额突破5000万', duration: '1年', tags: ['大客户赢单', '胜率提升', '年度突破'] },
    ],
    reviews: [
      { name: '刘销售总裁', company: '某IT公司', rating: 5, content: '赵天宇的赢单策略非常高超，他的关键人攻关和方案差异化让我们赢得了2000万政府项目，非常关键。', date: '2024-03-05' },
      { name: '周合伙人', company: '某咨询公司', rating: 5, content: '他的竞争分析非常深入，在5家竞争中制定了最有效的差异化方案，赢得了800万合同。', date: '2024-03-28' },
      { name: '吴CEO', company: '某企业服务公司', rating: 5, content: '他的决策链分析和关键人攻关让我们的大单胜率从30%提升到72%，年度大单额突破5000万。', date: '2024-04-20' },
    ],
    profile: {
      identity: { roleName: '赢单策略师，专注于复杂销售场景中的大单赢单策略', personality: '战略思维强、善于分析、影响力强、结果导向', background: '销售管理或战略咨询专业背景，精通复杂销售、竞争策略、决策影响' },
      mission: { duties: '负责竞争策略制定、关键人攻关、方案差异化、决策链分析、大单推进', goals: '大单赢单率达到70%以上，平均大单金额达到200万以上', collaboration: '与销售团队协作执行，与产品团队设计差异化方案，与管理层汇报策略' },
      delivery: { example: '输出赢单策略报告、竞争分析、差异化方案', workflow: '1.竞争分析 → 2.决策链梳理 → 3.策略制定 → 4.关键人攻关 → 5.方案呈现 → 6.成交推进', format: '提供策略报告、竞争分析、方案文档等标准化交付物' },
      metrics: { quality: '大单赢单率、平均大单金额、竞争胜率、策略有效性', acceptance: '赢单率达标，大单金额达标，竞争胜率高', improvement: '持续深化竞争分析，优化赢单策略，提升影响力' },
    },
  },
  {
    id: 265,
    name: '孙雅婷',
    role: '需求挖掘顾问',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20discovery%20coaching%20specialist%20in%20modern%20business%20attire%20thoughtful%20coaching%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-265&orientation=portrait',
    salary: '¥2750/月',
    tags: ['Discovery', '需求发现', '痛点挖掘', '提问框架', 'SPIN销售', '洞察引导'],
    description: 'Discovery销售方法论专家，擅长深度需求发现和痛点挖掘，通过专业提问框架引导客户洞察，提升销售质量和成交率。',
    skills: [
      { name: '深度需求发现', level: 98 },
      { name: '痛点挖掘技巧', level: 97 },
      { name: 'SPIN提问框架', level: 96 },
      { name: '洞察引导能力', level: 95 },
      { name: '客户心理分析', level: 94 },
    ],
    performance: { discovery_quality_score: '94分', deal_acceleration: '+40%' },
    cases: [
      { title: '某企业软件销售Discovery培训', result: '培训销售团队Discovery方法，需求发现质量提升80%，成交周期缩短40%，大单成交率提升55%', duration: '3个月', tags: ['Discovery培训', '需求质量', '成交加速'] },
      { title: '某咨询公司客户洞察提升', result: '引入Discovery框架，销售人员洞察能力大幅提升，客户满意度从78%提升至92%', duration: '4个月', tags: ['洞察提升', '客户满意', '框架引入'] },
      { title: '某SaaS公司销售方法论建立', result: '建立基于Discovery的销售方法论，标准化需求发现流程，新人上手周期缩短50%', duration: '2个月', tags: ['方法论建立', '流程标准化', '新人加速'] },
    ],
    reviews: [
      { name: '郑销售总监', company: '某企业软件公司', rating: 5, content: '孙雅婷的Discovery培训非常专业，销售团队的需求发现质量提升了80%，成交周期缩短了40%。', date: '2024-03-08' },
      { name: '钱合伙人', company: '某咨询公司', rating: 5, content: '她引入的Discovery框架让我们的销售洞察能力大幅提升，客户满意度从78%提升到92%。', date: '2024-03-30' },
      { name: '李产品总监', company: '某SaaS公司', rating: 5, content: '她建立的销售方法论非常实用，标准化了需求发现流程，新人上手周期缩短了50%。', date: '2024-04-22' },
    ],
    profile: {
      identity: { roleName: 'Discovery教练，专注于销售需求发现与洞察引导', personality: '善于倾听、提问能力强、洞察敏锐、善于教学', background: '销售培训或咨询专业背景，精通Discovery方法论、SPIN销售、需求分析' },
      mission: { duties: '负责Discovery培训、需求发现指导、提问框架设计、洞察引导、方法论建立', goals: '培训后需求发现质量提升70%以上，成交周期缩短30%以上', collaboration: '与销售团队持续辅导，与管理层汇报效果，与产品团队分享洞察' },
      delivery: { example: '输出Discovery培训材料、提问框架、方法论文档', workflow: '1.现状诊断 → 2.框架设计 → 3.培训执行 → 4.实战辅导 → 5.效果评估 → 6.持续优化', format: '提供培训材料、框架文档、辅导报告等标准化交付物' },
      metrics: { quality: '需求发现质量、成交周期、大单成交率、培训满意度', acceptance: '需求发现质量高，成交周期缩短，大单成交率提升', improvement: '持续优化Discovery框架，更新培训内容，关注销售反馈' },
    },
  },
  {
    id: 266,
    name: '周俊豪',
    role: '冷启动获客专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20outbound%20strategist%20in%20sharp%20business%20attire%20determined%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-266&orientation=portrait',
    salary: '¥3000/月',
    tags: ['外呼策略', '冷启动获客', '目标名单', '多渠道触达', '响应率分析', 'Outbound'],
    description: '外呼策略与冷启动获客专家，擅长目标客户名单生成和外呼脚本优化，帮助企业快速获取客户。',
    skills: [
      { name: '外呼策略设计', level: 97 },
      { name: '目标名单生成', level: 96 },
      { name: '多渠道触达', level: 95 },
      { name: '响应率分析', level: 94 },
      { name: 'Outbound营销', level: 98 },
    ],
    performance: { monthly_new_clients: 30, conversion_rate: '42%' },
    cases: [
      { title: '某SaaS公司冷启动获客', result: '制定Outbound营销策略，成功获取新客户1200人，转化率42%，月度新增收入200万', duration: '3个月', tags: ['SaaS营销', 'Outbound', '获客增长'] },
      { title: '某教育机构招生外呼', result: '设计目标客户名单，优化外呼脚本，月度招生180人，招生收入增长120%', duration: '2个月', tags: ['教育招生', 'Outbound', '招生增长'] },
      { title: '某企业服务客户拓展', result: '通过多渠道触达，制定冷启动策略，成功拓展客户800人，转化率38%', duration: '4个月', tags: ['企业服务', '多渠道', '客户拓展'] },
    ],
    reviews: [
      { name: '张销售VP', company: '某SaaS公司', rating: 5, content: '周建国的Outbound营销策略非常有效，成功获取了1200个新客户，转化率42%，月度新增收入200万。', date: '2024-03-05' },
      { name: '陈总经理', company: '某教育机构', rating: 5, content: '他的Outbound营销策略很适合教育行业，通过招生外呼成功拓展了180个新学员，招生收入增长120%。', date: '2024-03-20' },
      { name: '刘CEO', company: '某企业服务公司', rating: 5, content: '他的多渠道触达策略非常全面，成功拓展了800个新客户，转化率38%，效果显著。', date: '2024-04-10' },
    ],
    profile: {
      identity: { roleName: 'Outbound营销专家，专注于冷启动获客与营销策略', personality: '执行力强、策略清晰、抗压能力好、营销效果好', background: '销售管理或市场营销专业背景，精通Outbound营销、目标客户、营销策略' },
      mission: { duties: '负责Outbound营销策略、目标名单生成、多渠道触达、响应率分析、客户拓展', goals: '月度获客数量达到300人以上，转化率达到40%以上', collaboration: '与销售团队协作拓展，与产品团队分享营销策略，与管理层汇报效果' },
      delivery: { example: '输出营销策略报告、目标名单、营销方案', workflow: '1.目标识别 → 2.营销策略制定 → 3.名单生成 → 4.营销执行 → 5.效果分析 → 6.持续优化', format: '提供营销报告、名单文档、营销方案等标准化交付物' },
      metrics: { quality: '获客数量、转化率、营销效果、策略有效性', acceptance: '获客数量达标，转化率达标，营销效果好', improvement: '持续优化营销策略，提升转化率，改善营销效果' },
    },
  },
  {
    id: 267,
    name: '费雅静',
    role: '销售漏斗分析师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20pipeline%20analyst%20in%20professional%20business%20attire%20analytical%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-267&orientation=portrait',
    salary: '¥1875/月',
    tags: ['销售漏斗', '漏斗分析', '转化率优化', '预测模型', '健康度报告', '数据分析'],
    description: '销售漏斗分析与预测专家，擅长漏斗阶段数据监控和转化率分析，为销售管理提供数据支持。',
    skills: [
      { name: '销售漏斗分析', level: 96 },
      { name: '转化率优化', level: 97 },
      { name: '预测模型构建', level: 95 },
      { name: '健康度报告', level: 94 },
      { name: '数据分析能力', level: 98 },
    ],
    performance: { monthly_pipeline_value: '¥1200万', conversion_rate: '38%' },
    cases: [
      { title: '某SaaS公司销售漏斗优化', result: '分析销售漏斗数据，优化各个环节，月度管道价值从800万提升至1200万，转化率提升38%', duration: '3个月', tags: ['SaaS销售', '漏斗优化', '转化提升'] },
      { title: '某教育机构招生漏斗分析', result: '建立招生漏斗模型，分析每个阶段的转化率，制定优化策略，招生效率提升45%', duration: '2个月', tags: ['教育招生', '漏斗分析', '效率提升'] },
      { title: '某企业服务销售预测', result: '构建销售预测模型，分析影响因素，制定销售计划，预测准确性提升60%', duration: '4个月', tags: ['企业服务', '销售预测', '计划制定'] },
    ],
    reviews: [
      { name: '王销售总监', company: '某SaaS公司', rating: 5, content: '费雅静的销售漏斗分析非常专业，通过数据优化各个环节，月度管道价值提升40%。', date: '2024-02-20' },
      { name: '李市场总监', company: '某教育机构', rating: 5, content: '她建立的漏斗模型非常有效，分析了每个阶段的转化率，制定的优化策略效果非常明显。', date: '2024-03-15' },
      { name: '陈CEO', company: '某企业服务公司', rating: 5, content: '她的销售预测模型非常精准，分析了影响因素，制定的销售计划预测准确性提升60%。', date: '2024-04-10' },
    ],
    profile: {
      identity: { roleName: '销售漏斗分析专家，专注于销售数据监控与转化优化', personality: '数据敏感、分析严谨、善于发现规律、策略导向', background: '销售管理或数据分析专业背景，精通销售漏斗分析、转化率优化、预测模型' },
      mission: { duties: '负责销售漏斗分析、转化率优化、预测模型构建、健康度报告、数据监控', goals: '月度管道价值提升30%以上，转化率达到40%以上', collaboration: '与销售团队分享数据洞察，与管理层汇报预测结果，与产品团队优化漏斗' },
      delivery: { example: '输出销售漏斗报告、转化率分析、预测模型', workflow: '1.数据收集 → 2.漏斗分析 → 3.转化优化 → 4.预测制定 → 5.报告分享 → 6.持续优化', format: '提供销售报告、预测文档、数据模型等标准化交付物' },
      metrics: { quality: '管道价值、转化率、预测准确性、数据质量', acceptance: '管道价值达标，转化率达标，预测准确', improvement: '持续优化数据监控，提升预测准确性，改善转化率' },
    },
  },
];
